<template>
  <div>
    <h1 class="display-3">OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO</h1><br/>

    <b-row>
      <b-col cols="11">
        <p>
          W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie
          zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa
          do żołnierzy Armii Krajowej Okręgu Wileńskiego.
        </p>

        <p>
          Pierwszą legalnie organizowaną uroczystością o zasięgu krajowym było odsłonięcie tablicy epitafijnej poświęconej
          komendantowi żołnierzom 3. Brygady „Szczerbca” por. Gracjana Fróga w kościele pw. Św. Bartłomieja. Powstanie
          idei ufundowania tej tablicy sięga roku 1966 kiedy powstało nielegalne w ówczesnych czasach Środowisko 3.
          Brygady „Szczerbca”. Pomysłodawcami budowy tej tablicy byli: Sabina Korejwo „Sabina”, Marian Korejwo „Milimetr”,
          Zdzisław Christa „Mamut”, Tadeusz Dunowski „Ali” i inni. Pomimo silnych interwencji organów Służby Bezpieczeństwa
          w stosunku do inicjatorów jak i projektanta tablicy została ona wykonana, zamocowana i poświęcona 25.09.1971 r.
        </p>

        <p>
          W tym samym czasie czynnie działały Środowiska innych Brygad i Kół żołnierzy Armii Krajowej Okręgu
          Wileńskiego we Wrocławiu, Łodzi, Szczecinie, Olsztynie i Warszawie. Środowiska te próbowały oficjalnie
          organizować na swoim terenie Kluby Żołnierzy Armii Krajowej Okręgu Wileńskiego jako jednostki legalne w
          ramach jedynego Związku Kombatanckiego ZBoWiD, nie wszędzie to się udawało.
        </p>

        <p>
          W tym samym czasie istniała już tzw. Rada Starszych, którą tworzyli żyjący oficerowie Komendy
          Okręgu i dowódcy Brygad i Oddziałów.
        </p>

        <p>
          W roku 1990 został sądownie zarejestrowany Światowy Związek Żołnierzy Armii Krajowej (ŚZŻAK),
          do którego czynne Środowiska Brygadowe i Koła Okręgowe wstąpiły gremialnie. Statut ŚZŻAK przewidywał
          podział jednostek na Koła zrzeszające żołnierzy Armii Krajowej mieszkających na obszarze działalności
          Koła bez względu na przynależność do Okręgów AK oraz Środowiska zrzeszające żołnierzy danej jednostki
          bojowej bez względu na miejsce bieżącego zamieszkania.
        </p>

        <p>
          W roku 1992 Środowisko Wileńskie w Gdańsku zgłosiło swój akces do Okręgu Wileńskiego ŚZŻAK. Od tego czasu
          Okręg Wileński obejmował swoją działalnością dwa Środowiska: Warszawskie i Gdańskie. Oba Środowiska działały
          samodzielnie wg uchwalonych programów przez swoje Walne Zgromadzenia i posiadanych środków finansowych.
        </p>

        <p>
          Drugim Prezesem Okręgu Wileńskiego został , wybrany na Walnym Zebraniu Sprawozdawczo-Wyborczym kol. Lech Iwanowski
          „Lancet” żołnierz 3. Brygady „Szczerbca”. Pierwszym Prezesem Okręgu Wileńskiego ŚZŻAK został kol.
          Ryszard Andrys-Jankowski „Orlik”.
        </p>

        <b-row>
          <b-col v-for="profile in okreg_wilenski.profiles" :key="profile.id"
          :xl="profile.cols.xl" :lg="profile.cols.lg" :md="profile.cols.md" :cols="profile.cols.sm">
            <b-card
              :img-src="profile.img"
              img-top
              tag="article"
              style="width: 10em; min-height: 24em;"
              class="mb-2">
              <p class="card-text">
                {{profile.text}}
              </p>
            </b-card>
          </b-col>
        </b-row>

        <p>
          Dnia 20 września 2012 roku na skutek pogarszającego się stanu zdrowia zrezygnował ze stanowiska prezesa
          Okręgu Wileńskiego. Na jego miejsce wybrano wiceprezesa okręgu Włodzimierza Mikucia, na okres zorganizowania
          zjazdu delegatów i zarządów środowisk i wybrania nowego prezesa.
        </p>

        <p>
          Trzecim Prezesem Zarządu Okręgu Wileńskiego ŚZŻAK został kol. Ludwik Świda „Błysk”, również żołnierz 3.
          Brygady. Funkcje tą pełnił przez dwie kadencje. Jego podstawową działalnością w tym okresie było
          organizowanie trzech kolejnych spotkań historyków polskich i litewskimi dla uzgodnień na podstawie
          materiałów źródłowych działalności Armii Krajowej na terytorium Polskiego Państwa Podziemnego na obszarze
          Województwa Wileńskiego do czasu podpisania Kontraktu zmieniającego granice Państwa Polskiego tzn. do 14 lutego 1946 roku.
        </p>

        <b-row>
          <b-col md="7">
            <p>
              Po rozwiązaniu w Gdańsku Komisji Historycznej Okręgu Wileńskiego, na zebraniu plenarnym Zarządu
              wybrano nową komisję Historyczną Okręgu Wileńskiego. Przewodniczącym został Jan Leszek Malinowski „Orland”.
              Podął się kontynuowania wydawania periodyku Okręgu Wileńskiego pod zmienionym tytułem i wprowadzeniu
              informacji z bieżącej działalności Zarządu i podległych Środowisk. Należność dla drukarni opłacać będzie Zarząd Okręgu.
            </p>
            <p>
              Organizował remonty i odbudowywanie cmentarzy Żołnierzy Armii Krajowej przez Radę Ochrony Pamięci Walk i
              Męczeństwa na terenie Wileńszczyzny. W tym okresie odbudowano i wyremontowano następujące cmentarze: w
              Kolonii Wileńskiej, Kalwarii Wileńskiej, w Wilnie na Rossie, w Puszczy Rudnickiej żołnierzy „Komara”, w
              Wodzianach i Marcebolinie.
              Czwartym Prezesem do dnia 28 kwietnia 2011 roku był kol. Henryk Szostakowski.
              Piątym Prezesem Okręgu Wileńskiego 28 kwietnia 2011 roku został wybrany kol. Janusz Bohdanowicz „Czortek” przez delegatów Środowisk Wileńskich w Gdańsku i Warszawie, jednocześnie pozostając prezesem Środowiska Wileńskiego w Warszawie.
              Działalność Środowisk Okręgu Wileńskiego przedstawiamy indywidualnie.
            </p>
          </b-col>
          <b-col md="5">
            <b-img center src="/srodowiska/okreg_wilenski/pamietnik_okregu_wilenskiego.jpg" center fluid/>
          </b-col>
        </b-row>

        <p class="display-4">Cmentarze żołnierzy</p>
        <p class="lead"> Armii Krajowej na Wileńszczyźnie</p>
        <p>
          Największym odrestaurowanym cmentarzem poległych żołnierzy Armii Krajowej na Wileńszczyźnie jest
          cmentarz w Wilnie na Rossie, przy mauzoleum serca Marszałka Polski Józefa Piłsudskiego. Pozostałe w
          kolejności dat ich odbudowy:
        </p>
        <ul>
          <li>w Skorbucianach pod Wilnem – cmentarz 7. Brygady „Wilhelma”, </li>
          <li>w Mikuliszkach – obecnie Białoruś – cmentarz 3. Brygady „Szczerbca” i 6. Brygady „Tońki”, </li>
          <li>w Koleśnikach – cmentarz 6. Brygady „Konara”, </li>
          <li>w Worzianach – obecnie Białoruś – cmentarz 5. Brygady „Łupaszki”, </li>
          <li>w Kalwarii Wileńskiej – cmentarz poległych w walkach o Wilno z 1. Brygady „Juranda”, 4. Brygady „Ronina”, 36. Brygady „Wujka”, </li>
          <li>w Kolonii Wileńskiej – cmentarz poległych w walkach o Wilno żołnierzy 3. Brygady „Szczerbca”i II batalionu „Krysi”, </li>
          <li>pod Marcebolinem – obecnie Białoruś - cmentarz żołnierzy 23. Brygady „Ostrogi”, </li>
          <li>Puszcza Rudnicka – miejsce pochówku – poległych żołnierzy Oddziału „Komara”, </li>
          <li>nad jeziorem Narocz– prawdopodobne miejsce egzekucji 80 żołnierzy Oddziału „Kmicica”,</li>
          <li>Nowosady – obecnie Białoruś – cmentarz żołnierzy Oddziału „Edka”, </li>
          <li>Ławże koło Oszmiany – obecnie Białoruś – miejsce pochówku żołnierzy Oddziału W. Mikuća „Jarema”. </li>
          <li>Graużyszki – obecnie Białoruś – cmentarz żołnierzy 13. Brygady „Nietoperza” i 8. Brygady Tura”, </li>
          <li>Dubicze – cmentarz pochowanych po ekshumacji prochów żołnierzy 6. Brygady „Konara” i II batalionu 77 pp. AK „Krysi”, </li>
          <li>Ejszyszki – cmentarz pochowanych po ekshumacji prochów dowódcy II batalionu 77 pp. AK „Krysi” i jego żołnierzy,</li>
          <li>Glinciszki koło Podbrzezia - cmentarz 38 mieszkańców Glińczyszek zamordowanych przez policję Litewską z posterunku w Podbrzeziu w dniu 30 czerwca 1944r.</li>
        </ul>
        <p>
          Na kilkunastu cmentarzach parafialnych na terenie obecnej Litwy i Białorusi postawiono
          nowe jednolite krzyże z tabliczkami epitafijnymi.
        </p>
      </b-col>
    </b-row>

    <b-row class="mb-5" v-for="video in okreg_wilenski.videos" :key="video.id">
      <b-col md="7">
        <b-embed type="iframe"
          aspect="16by9"
          :src="video.url"
          allowfullscreen
        ></b-embed>
      </b-col>
      <b-col md="4" class="lead">
        {{video.text}}
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p class="display-4">Glinciszki</p>
        <p>
          Zaczęło się w Glinciszkach koło Podbrzezia. Był to majątek Jeleńskich administrowany przymusowo
          przez Landbweirtschafungsgessellschaft Ostland (LO), w grupie majątków, której dyrektorem był
          Władysław Komar. Nad ranem 20 czerwca patrol 5 Brygady dowodzony przez Antoniego Rymszę „Maksa”
          urządził koło Glinciszek zasadzkę, w którą wpadł litewski patrol policyjny, tracąc 4 zabitych.
        </p>

        <p>
          Kilka godzin później przybył z Podbrzezia oddział 258 batalionu litewskiego pod dowództwem por.
          Polekauskasa i dokonał krwawego odwetu, zabijając 10 Polaków za 1 Litwina. Zamordowano ogółem 38 osób, wśród
          których – oprócz mieszkańców miejscowych – znalazło się kilka przypadkowych osób. Masakrę opisał naoczny świadek,
          czternastoletni wówczas Henryk Konieczny, który wyszedł wcześniej z ogrodu, skąd – ukryty za krzakiem – obserwował
          przebieg masakry. Rozstrzeliwano partiami, nie szczędząc nikogo – dzieci, starców, kobiet. Zabito między innymi
          czworo małych dzieci od 3 do 5 lat i czworo ludzi starych, od 63 do 84 lat. Jedenastu mężczyzn sprowadzonych
          specjalnie przez policję musiał wykopać dół, do którego byle jak wrzucono ciała ofiar.
        </p>

        <p>
          Wieść o zbrodni dotarła telefonicznie do Komara, który natychmiast wyruszył do Glinciszek samochodem
          służbowym w towarzystwie zastępcy kierownika LO – Niemca Hofmanna - i niemieckiego kierowcy.
          Po zorientowaniu się na miejscu o tragicznym wydarzeniu, Komar wyruszył w drogę powrotną do Wilna
          przez Podbrzezie. Tu doszło do nowej tragedii. Litwini zatrzymali samochód, wyciągnęli z niego Komara,
          a Niemcom kazali jechać dalej. Komar wyrwał się litewskim policjantom, lecz przy próbie ucieczki został zastrzelony.
        </p>

        <p>
          Wśród Litwinów panowało podobno przekonanie, że zlikwidowali komendanta AK „Wilka”.
        </p>

        <p>
          Wkrótce przybyli do Glinciszek niemieccy policjanci wraz z przedstawicielami LO. Po przeprowadzeniu
          dochodzenia ściągnęli z Podbrzezia Litwinów i kazali im dokonać ekshumacji zwłok. Ekshumacje przeprowadzono,
          zwłoki włożono do trumien i pogrzebano nieopodal drogi do Podbrzezia. Władysław Komar za zgodą Gebietskommissara
          Wolffa został pochowany przez rodzinę na Rossie.
        </p>

        <p>
          Protokół ekshumacji sporządziła Irena Sławinska, pracowniczka kancelarii majątku Glinciszki.
          Była ona absolwentką wydziału humanistycznego USB i poza pracą w kancelarii prowadziła dla miejscowej
          młodzieży komplety tajnego nauczania. Odpis protokołu zachowała , dzięki czemu znana jest pełna
          lista ofiar potwornej zbrodni.
        </p>

        <p>
          Na rozkaz naczelnika niemieckiego sztabu zwalczania partyzantów Musila aresztowano dowódcę oddziału
          litewskiego Polekauskasa, odpowiedzialnego za dokonanie masakry, i 33 żołnierzy. Stanęli oni przed sądem SS.
        </p>

        <p class="text-right">Longin Tomaszewski</p>
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col cols="10" xl="6" >
        <b-carousel
          style="text-shadow: 1px 1px 2px #333; margin: 0 0em 2em 0em;"
          controls
          indicators
          background="#ababab"
          :interval="0"
          class="carousel_okreg"
        >
          <div v-for="carousel in okreg_wilenski.carousel" :key="carousel.id">
            <b-carousel-slide
              :caption="carousel.title"
              :text="carousel.text"
              :img-src="carousel.img"
            ></b-carousel-slide>
          </div>
        </b-carousel>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import okreg_wilenski from '@/models/srodowiska/okreg_wilenski.js'

export default {
  name: 'okreg_wilenski',
  data: function(){
    return{
      okreg_wilenski: okreg_wilenski
    }
  },
  metaInfo:{
    title: 'OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO',
    meta:[
      {name: 'description', content: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego' },
      {name: 'og:url', content: 'http://akwilno.pl/srodowiska/okreg_wilenski' },
      {name: 'og:title', content: 'OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO' },
      {name: 'og:image', content: '/srodowiska/okreg_wilenski.jpg' },
      {name: 'og:description', content: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego' },
      {name: 'twitter:url', content: 'http://akwilno.pl/srodowiska/okreg_wilenski' },
      {name: 'twitter:title', content: 'OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO' },
      {name: 'witter:image', content: '/srodowiska/okreg_wilenski.jpg' },
      {name: 'twitter:description', content: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego' }
    ]
  }
}
</script>

<style>
  .carousel_okreg .carousel-caption,
  .carousel_okreg .carousel-control-prev-icon,
  .carousel_okreg .carousel-control-next-icon{
    background-color: rgba(0, 0, 0, 0.4)
  }
</style>



// WEBPACK FOOTER //
// src/components/srodowiska/okreg_wilenski.vue